// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"45":"12819d1b98875859","243":"5c5974ea0c6e7b7d"}[chunkId] + ".css";
};